/* Synchronized companion controls: the native product form remains the purchase authority. */
(() => {
  if (window.ih3PurchaseControls) return;
  window.ih3PurchaseControls = true;
  let scheduled = false;
  let restoreFocus = null;
  const nativePicker = root => root.querySelector('variant-selects');
  const nativeQuantity = root => root.querySelector('input[name="quantity"]:not([data-3d-quantity])');
  const submit = root => root.querySelector('product-form button[type="submit"]');
  const groups = root => {
    const picker = nativePicker(root);
    if (!picker) return [];
    return [...picker.querySelectorAll('select, fieldset')].map((control, index) => {
      const label = control.tagName === 'SELECT'
        ? picker.querySelector(`label[for="${CSS.escape(control.id)}"]`)?.textContent.trim()
        : control.querySelector('legend')?.textContent.trim();
      const options = control.tagName === 'SELECT'
        ? [...control.options].map(o => ({ value: o.value, label: o.textContent.trim(), selected: o.selected, disabled: o.disabled }))
        : [...control.querySelectorAll('input[type="radio"]')].map(o => ({ value: o.value, label: o.value, selected: o.checked, disabled: o.disabled }));
      return { control, label: label || `Option ${index + 1}`, options };
    }).filter(group => group.options.length > 1);
  };
  const sanitize = node => {
    const copy = node.cloneNode(true);
    copy.removeAttribute('id');
    copy.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
    return copy.innerHTML;
  };
  function refresh(root) {
    const anchor = root.querySelector('[data-variant-model-desktop-anchor]');
    const model = root.querySelector('model-viewer');
    if (!anchor || !model) { root.querySelector('[data-3d-purchase]')?.remove(); return; }
    let panel = root.querySelector('[data-3d-purchase]');
    if (!panel) {
      panel = document.createElement('section');
      panel.dataset['3dPurchase'] = '';
      panel.dataset.ihFeature = 'product_3d_purchase';
      panel.dataset.ihResource = 'purchase_controls';
      panel.className = 'product-3d-purchase';
      panel.innerHTML = '<h3>Choose your hardware</h3><div data-3d-options></div><div data-3d-price aria-live="polite"></div><div class="product-3d-purchase__actions"><label>Quantity<input data-3d-quantity type="number" inputmode="numeric" value="1" aria-label="Quantity by 3D view"></label><button type="button" class="button button--primary" data-3d-add data-ih-action="add_to_cart_request" data-ih-resource="native_product_form">Add to cart</button></div><p data-3d-error role="status"></p>';
      panel.addEventListener('change', event => {
        const select = event.target.closest('[data-3d-option]');
        if (select) {
          const group = groups(root)[Number(select.dataset['3dOption'])];
          const control = group?.control;
          if (!control) return;
          let target = control;
          if (control.tagName === 'SELECT') control.value = select.value;
          else { target = [...control.querySelectorAll('input')].find(i => i.value === select.value); if (!target) return; target.checked = true; }
          restoreFocus = { nativeId: target.id, lower: select, y: scrollY };
          target.dispatchEvent(new Event('change', { bubbles: true }));
          panel.querySelector('[data-3d-add]').disabled = true;
        }
        if (event.target.matches('[data-3d-quantity]')) {
          const q = nativeQuantity(root);
          if (q) { q.value = event.target.value; q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      });
      panel.querySelector('[data-3d-add]').addEventListener('click', () => {
        const lower = panel.querySelector('[data-3d-quantity]');
        if (!lower.reportValidity()) return;
        const q = nativeQuantity(root);
        if (q && !q.reportValidity()) return;
        submit(root)?.click();
      });
    }
    // The current layout moves viewer frames between anchors at responsive breakpoints.
    const frame = model.closest('.variant-model__product-frame');
    const host = root.querySelector('[data-bold-tools]') || frame?.parentElement;
    if (host && panel.parentElement !== host) host.append(panel);
    const optionsRoot = panel.querySelector('[data-3d-options]');
    const list = groups(root);
    const signature = JSON.stringify(list.map(({label, options}) => ({label, options})));
    if (optionsRoot.dataset.signature !== signature) {
      const active = document.activeElement?.dataset['3dOption'];
      optionsRoot.replaceChildren(...list.map((group, index) => {
        const label = document.createElement('label'); label.textContent = group.label;
        const select = document.createElement('select'); select.dataset['3dOption'] = String(index); select.id = `${root.id}-3d-option-${index}`;
        select.dataset.ihAction = 'variant_select'; select.dataset.ihResource = `option_${index + 1}`;
        group.options.forEach(o => { const option = new Option(o.label, o.value, false, o.selected); option.disabled = o.disabled; select.add(option); });
        label.append(select); return label;
      }));
      optionsRoot.dataset.signature = signature;
      if (active !== undefined) optionsRoot.querySelector(`[data-3d-option="${active}"]`)?.focus({ preventScroll: true });
    }
    const price = root.querySelector('[id^="price-"]');
    const priceHtml = price && !price.classList.contains('hidden') ? sanitize(price) : '';
    const lowerPrice = panel.querySelector('[data-3d-price]');
    if (lowerPrice.innerHTML !== priceHtml) lowerPrice.innerHTML = priceHtml;
    const q = nativeQuantity(root), lower = panel.querySelector('[data-3d-quantity]');
    if (q) { for (const attr of ['min', 'max', 'step']) { if (q.hasAttribute(attr)) lower.setAttribute(attr, q.getAttribute(attr)); else lower.removeAttribute(attr); } if (document.activeElement !== lower) lower.value = q.value; }
    const button = submit(root), lowerButton = panel.querySelector('[data-3d-add]');
    lowerButton.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
    const text = button?.querySelector('span')?.textContent.trim() || button?.textContent.trim() || 'Unavailable';
    if (lowerButton.textContent !== text) lowerButton.textContent = text;
    const error = root.querySelector('product-form .product-form__error-message')?.textContent.trim() || '';
    if (panel.querySelector('[data-3d-error]').textContent !== error) panel.querySelector('[data-3d-error]').textContent = error;
  }
  const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; document.querySelectorAll('product-info').forEach(refresh); }); };
  document.addEventListener('focusin', event => {
    if (restoreFocus && event.target.id === restoreFocus.nativeId) {
      const { lower, y } = restoreFocus; restoreFocus = null;
      const replacement = document.getElementById(lower.id);
      replacement?.focus({ preventScroll: true }); scrollTo({ top: y, behavior: 'instant' });
      requestAnimationFrame(() => scrollTo({ top: y, behavior: 'instant' }));
    }
  });
  document.addEventListener('input', e => { if (e.target.matches('input[name="quantity"]')) schedule(); });
  document.addEventListener('change', schedule);
  document.addEventListener('product-info:loaded', schedule);
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('variant-selects')) restoreFocus = null;
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const current = document.querySelector('[data-3d-test-product-index]');
      const incoming = data.html?.querySelector('[data-3d-test-product-index]');
      if (current && incoming) current.textContent = incoming.textContent;
      schedule();
      if (restoreFocus) {
        const pending = restoreFocus;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          document.getElementById(pending.lower.id)?.focus({ preventScroll: true });
          scrollTo({ top: pending.y, behavior: 'instant' });
          if (restoreFocus === pending) restoreFocus = null;
        }));
      }
    });
  }
  new MutationObserver(records => { if (records.some(r => !r.target.closest?.('[data-3d-purchase]'))) schedule(); }).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value','data-has-model']});
  schedule();
})();
